<template>
  <div>
    <div class="row m-0 mb-4 align-items-center justify-content-between">
      <h3 class="mb-0">Embed</h3>
    </div>
    <div class="c3-container">
      <a class="c3-button" :href="currentDomain" target="_blank">
        <img :src="embedImage" class="c3-image" />
        Send referrals through C3!
      </a>
      <p class="mt-2 mb-2 c3-note">
        Copy and paste this code into your website:
      </p>
      <textarea readonly class="c3-area" v-model="message"> </textarea>

      <div class="c3-copy">
        <img src="/images/copy.png" class="c3-copy-icn mr-1" />
        <button
          v-clipboard:copy="message"
          v-clipboard:success="copiedToClibboard"
          class="btn btn-link c3-link-copy"
        >
          Copy Code
        </button>
        <img
          src="/images/check-mark.svg"
          class="ml-1 copied-icn"
          :class="copied ? 'copied' : ''"
        />
      </div>
      <h3 class="text-center or-text"><span>OR</span></h3>
      <img src="/images/QR-code.png" class="c3-qr-image" />
    </div>
  </div>
</template>

<script>
export default {
  name: "EmbedCode",
  data() {
    return {
      copied: false,
      currentDomain: `${window.location.origin}`,
      embedImage: `${window.location.origin}/favicon/favicon-96.png`,
      message: `<a class="c3-button" href="${window.location.origin}" target="_blank">
        <img src="${window.location.origin}/favicon/favicon-96.png" class="c3-image" /> Send referrals through C3!
      </a>
      <style>
      .c3-button {
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          background-color: #eeeeee;
          background-image: -webkit-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: -webkit-linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: -moz-linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: -ms-linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: -o-linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
          border: 1px solid #c0c0c0;
          border-radius: 8px;
          color: #000000;
          font-weight: bold;
          padding: 12px;
          text-align: center;
          text-shadow: 0 1px 0 #eee;
          font-size: 14px;
          font-family: "Cerebri Sans",sans-serif;
          margin-bottom: 12px;
        }

        .c3-button:hover {
          background-image: -webkit-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: -webkit-linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: -moz-linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: -ms-linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: -o-linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
          background-image: linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
        }

        .c3-area {
          width: 100%;
          border: 1px solid #cccccc;
          background-color: #ffffff;
          outline: none !important;
          font-size: 12px;
          min-height: 100px;
        }

        .c3-image {
          width: 30px;
          height: 30px;
          max-width: 30px;
          max-height: 30px;
          margin-right: 8px;
        }
        .c3-note {
          color: #6C6B66;
          font-weight: 500;
          font-size: 14px;
        }
        .c3-copy-icn {
          width: 25px;
        }
        .c3-link-copy {
          text-decoration: underline;
        }

        .copied-icn {
          width: 20px;
          opacity: 0;
          transition: opacity 0.5s ease-in-out;
        }
        .copied-icn.copied {
          opacity: 1;
        }
      </style>`,
    };
  },
  methods: {
    copiedToClibboard: function () {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 3000);
    },
  },
};
</script>

<style scoped lang="scss">
.c3-button {
  display: inline-flex;
  text-decoration: none;
  align-items: center;
  background-color: #eeeeee;
  background-image: -webkit-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: -webkit-linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: -moz-linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: -ms-linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: -o-linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: linear-gradient(180deg, #f7f9fa 0%, #dee1e2 100%);
  border: 1px solid #c0c0c0;
  border-radius: 8px;
  color: #000000;
  font-weight: bold;
  padding: 12px;
  text-align: center;
  text-shadow: 0 1px 0 #eee;
  font-size: 14px;
  font-family: "Cerebri Sans", sans-serif;
  margin-bottom: 12px;
}

.c3-button:hover {
  background-image: -webkit-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: -webkit-linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: -moz-linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: -ms-linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: -o-linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
  background-image: linear-gradient(0deg, #f7f9fa 0%, #dee1e2 100%);
}

.c3-area {
  width: 100%;
  border: 1px solid #cccccc;
  background-color: #ffffff;
  outline: none !important;
  font-size: 12px;
  min-height: 100px;
}

.c3-image {
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
  margin-right: 8px;
}

.c3-qr-image {
  box-shadow: 0px 0px 6px 4px #0a3352;
  width: 90%;
  height: 90%;
  max-width: 90%;
  max-height: 90%;
  margin-left: 5%;
}

.or-text {
  width: 90%;
  margin: 24px 5%;
  border-bottom: 3px solid #0a3352;
  color: #0a3352;
  line-height: 0.1em;
  span {
    background: #fff;
    padding: 0 10px;
  }
}

.c3-note {
  color: #6c6b66;
  font-weight: 500;
  font-size: 14px;
}
.c3-copy-icn {
  width: 25px;
}
.c3-link-copy {
  text-decoration: underline;
}

.copied-icn {
  width: 20px;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.copied-icn.copied {
  opacity: 1;
}
</style>
